module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-map', {
    attrs: {
      "zoom": _vm.zoom,
      "center": _vm.center,
      "id": "map"
    }
  }, [_c('v-tilelayer', {
    attrs: {
      "url": _vm.url
    }
  }), _vm._v(" "), _vm._l((_vm.pointsDictionary), function(point) {
    return _c('v-marker', {
      key: point.uid,
      attrs: {
        "lat-lng": point.latlng,
        "title": point.name,
        "draggable": false
      }
    }, [_c('v-popup', {
      attrs: {
        "content": _vm.formatHeader(point.latlng, point.name)
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cb6f4c7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/MapView.vue
// module id = 817
// module chunks = 0